export const inquiryPropertyTypeEnum = {
    SINGLE_FAMILY_RESIDENCY: 'Single Family Residency',
    CONDO: 'Condo',
    TOWNHOME: 'Townhome',
    TWOTOFOUR: '2-4 Unit Multi-Family',
    FIVEPLUS: '5+ Unit Apartment',
};
